import React from "react";
import "./RightContainer.css";
import Rside from "./Rside/Rside";

const RightContainer = () => {
  return (
    <>
      <div className="rightContainer">
        <Rside />
      </div>
    </>
  );
};

export default RightContainer;
